import type * as React from 'react'
import { CloseIcon, IconButton } from '@buffer-mono/popcorn'

import { useAppSelector } from '~publish/legacy/store'
import { selectContentGenerationStatus } from '~publish/legacy/ai/state/slice'

import styles from './Prompt.module.css'

/**
 *
 */
function Prompt({
  expanded,
  lines,
  prompt,
  withBackground,
  onToggle,
  onClear,
}: {
  expanded: boolean
  prompt: string
  lines?: number
  withBackground?: boolean
  onToggle: () => void
  onClear: () => void
}): JSX.Element {
  const { contentGenerationInProgress } = useAppSelector((state) =>
    selectContentGenerationStatus(state),
  )

  const onClearClick = (
    event: React.MouseEvent | React.KeyboardEvent,
  ): void => {
    event.preventDefault()
    event.stopPropagation()
    onClear()
  }

  return (
    <div
      className={`${styles.wrapper} ${expanded ? styles.expanded : ''} ${
        withBackground ? styles.withBackground : ''
      } ${contentGenerationInProgress ? styles.disabled : ''}`}
      style={
        {
          '--lines': lines || 1,
        } as React.CSSProperties
      }
      onClick={contentGenerationInProgress ? undefined : onToggle}
      onKeyDown={contentGenerationInProgress ? undefined : onToggle}
    >
      <p data-testid="ai-assistant-prompt" className={styles.prompt}>
        {prompt}
      </p>
      {!contentGenerationInProgress && (
        <IconButton
          onClick={onClearClick}
          label="Clear prompt"
          size="small"
          variant="tertiary"
          data-testid="ai-assistant-clear-prompt-button"
          className={styles.clearButton}
        >
          <CloseIcon />
        </IconButton>
      )}
    </div>
  )
}

export { Prompt }
